import React, { useMemo } from "react"
import DropDown from "../../../../components/shared/dropdown"
import { RateCommissionTypes } from "../../../../components/shared/constants";
import { useTextResources } from "../../../../language";

export const RateCommisionTypeDropDown = (props) => {
    const text = useTextResources();
    const data = useMemo(() => Object.entries(RateCommissionTypes).map(([key, value]) => ({
        Id: value,
        Name: text(key),
    })), [text]);
    return <DropDown search={false} textField="Name" valueField="Id" data={data}  {...props} />
}